module.exports = __webpack_public_path__ + "static/media/endosee-accessories-thumb@3x.19d7be18.jpg";